module.exports = __webpack_public_path__ + "assets/legend-f42e47e05873ee9393d02258f8d4948e.svg";